import { SegmentedTabs } from "@c/shared/SegmentedTabs";
import { useTranslation } from "react-i18next";

const DAYS = [7, 30, 90] as const;

/**
 * The 7d / 30d / 90d quick range picker. Single source for the control that
 * used to be hand-rolled twice with two different looks (`.tap` Insights and
 * the `.360` AnalyticsPage). Any new analytics surface reuses this one.
 */
export function DayRangeTabs({
  value,
  onChange,
  className,
}: {
  value: number;
  onChange: (days: number) => void;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <SegmentedTabs
      size="sm"
      layout="auto"
      value={String(value)}
      onChange={(v) => onChange(Number(v))}
      options={DAYS.map((d) => ({
        value: String(d),
        label: (
          <span
            className="uppercase tracking-widest"
            aria-label={t("last_days", { count: d })}
          >
            {d}d
          </span>
        ),
      }))}
      className={className}
    />
  );
}
